import formatTableJson from '@/config/tableComponentParams.js'
import { enbaleDisableStatus } from '@/config/status'
export default formatTableJson([
  {
    filed: 'version',
    label: '版本号'
  },
  {
    filed: 'versionAlias',
    label: '版本别名'
  },
  {
    filed: 'fileLength',
    label: '固件大小',
    formatFn: function(_, row) {
      return row.fileLength ? Math.floor(row.fileLength / 1024) + 'KB' : '-'
    }
  },
  {
    filed: 'fileMd5',
    label: '固件MD5',
    width: 250,
    showOverflowTooltip: true
  },
  {
    filed: 'createTime',
    label: '创建时间',
    type: 'time',
    width: 170
  },
  {
    filed: 'creatorName',
    label: '创建人'
  },
  {
    filed: 'status',
    label: '状态',
    type: 'status',
    statusProps: enbaleDisableStatus,
    formatFn: function(_, row) {
      switch (row.status) {
        case 'ENABLE':
          return '启用'
        case 'DISABLED':
          return '禁用'
        default:
          return '-'
      }
    }
  }
])
